// src/dateUtils.js
// Форматирование дат на русском с правильными склонениями.

/**
 * Выбирает форму слова по числу.
 *
 * Русское правило: 1, 21, 31 — единственное; 2–4, 22–24 — «мало»;
 * 5–20, 25–30 и всё остальное — «много». Числа 11–14 всегда «много»,
 * это исключение из правила по последней цифре (11 часов, а не 11 час).
 *
 * plural(1,  'час', 'часа', 'часов') === 'час'
 * plural(19, 'час', 'часа', 'часов') === 'часов'
 * plural(22, 'час', 'часа', 'часов') === 'часа'
 */
export function plural(count, one, few, many) {
  const n = Math.abs(count) % 100;
  if (n >= 11 && n <= 14) return many;
  const last = n % 10;
  if (last === 1) return one;
  if (last >= 2 && last <= 4) return few;
  return many;
}

const absoluteDate = (date) =>
  date.toLocaleDateString('ru-RU', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });

/**
 * «Только что», «5 минут назад», «19 часов назад», «Вчера», «5 дней назад»,
 * а для дат старше недели — обычная дата.
 */
export function formatRelativeDate(dateString) {
  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) return '';

  const diff = Date.now() - date.getTime();

  // Дату публикации администратор может выставить вручную, в том числе
  // будущую. «-1 дня назад» в такой ситуации выглядело бы поломкой.
  if (diff < 0) return absoluteDate(date);

  const minutes = Math.floor(diff / 60000);
  if (minutes < 1) return 'Только что';
  if (minutes < 60) {
    return `${minutes} ${plural(minutes, 'минуту', 'минуты', 'минут')} назад`;
  }

  const hours = Math.floor(diff / 3600000);
  if (hours < 24) {
    return `${hours} ${plural(hours, 'час', 'часа', 'часов')} назад`;
  }

  const days = Math.floor(diff / 86400000);
  if (days === 1) return 'Вчера';
  if (days < 7) {
    return `${days} ${plural(days, 'день', 'дня', 'дней')} назад`;
  }

  return absoluteDate(date);
}
